<template>
    <v-container>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate
                                 size="64"></v-progress-circular>
        </v-overlay>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="primary">
                        <v-toolbar-title style="color: white;">
                            Recepción de Documentación
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon color="white">mdi-archive-outline</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="6" offset-md="3">
                                <v-list subheader three-line>
                                    <v-list-item v-if="valpq">
                                        <v-list-item-content>
                                            <v-list-item-title style="color: black !important;">Paquetería:</v-list-item-title>
                                            <v-list-item-subtitle style="color: black;"><h6>{{docto.pqnombre}}</h6></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="valpq">
                                        <v-list-item-content>
                                            <v-list-item-title>Guía:</v-list-item-title>
                                            <v-list-item-subtitle style="color: black;"><h6>{{docto.npguia}}</h6></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Observación de Envío:</v-list-item-title>
                                            <v-list-item-subtitle style="color: black;"><h6>{{docto.npobs}}</h6></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Reporte(s):</v-list-item-title>
                                            <v-data-table :headers="headres2"
                                                          v-model="selected"
                                                          item-key="Reporte"
                                                          :single-select="singleSelect"
                                                          show-select
                                                          hide-default-footer
                                                          :items="reportes">
                                            </v-data-table>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Fecha:</v-list-item-title>
                                            <v-menu ref="menu1"
                                                    v-model="menu1"
                                                    :close-on-content-click="false"
                                                    transition="scale-transition"
                                                    offset-y
                                                    max-width="290px"
                                                    min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="dateFormatted"
                                                                  outlined
                                                                  readonly
                                                                  v-bind="attrs"
                                                                  @blur="date = parseDate(dateFormatted)"
                                                                  v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="date"
                                                               locale="es-mx"
                                                               :max="maxfecha"
                                                               :min="mindate"
                                                               @input="menu1 = false"></v-date-picker>
                                            </v-menu>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Observaciones</v-list-item-title>
                                            <v-form ref="frm" v-model="valid" lazy-validation>
                                                <v-textarea :counter="500"
                                                            :rules="rulestextarea"
                                                            outlined
                                                            v-model="comentarios"
                                                            required
                                                            name="input-7-4"></v-textarea>
                                            </v-form>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                        
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <v-btn class="ma-2"
                                       color="primary"
                                       @click="Guardar()">
                                    Guardar
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                                <v-btn class="ma-2" @click="Limpiar()">
                                    Limpiar
                                </v-btn>
                                <v-btn class="ma-2" @click="Regresar()" color="error">
                                    Regresar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
    
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import Recepcion from '@/services/TramitePago/TramitePago.Service.js';
    import moment from "moment";

    export default {
        title() {
            return this.$route.meta.title
        },
        data: vm => ({
            valid: true,
            maxfecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
            menu1: false,
            comentarios: '',
            mindate: '',
            rulestextarea: [
                v => !!v || 'Campo requerido',
                v => {
                    if (v == null) {
                        return true
                    }
                    else {
                        if (v.length < 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > 500) {
                            return 'Máximo 500 Carácteres'
                        }
                        else
                            return true
                    }
                },
            ],
            headres2: [
                { text: 'Reporte', value: 'Reporte', class: "text title" },
                { text: 'Abogado', value: 'prnombre', class: "text title" },
                { text: 'Asistencia', value: 'Asistencia', class: "text title" },
                { text: 'Fecha Envio', value: 'fecha', class: "text title" }, 
            ],
            reportes: [],
            selected: [],
            singleSelect: false,
            valpq: false,
            overlay: false,
        }),
        props: ['docto'],
        computed: {
            ...mapState([
                "domain",
                "informationPage",
                "paginacion",
                "permission",
                "user"
            ]),
            computedDateFormatted() {
                return this.formatDate(this.date)
            },
        },
        watch: {
            date(val) {
                this.dateFormatted = this.formatDate(this.date)
            },
            overlay(val) {
                val && setTimeout(() => {
                    this.overlay = false
                }, 2000)
            },
        },
        methods: {
            formatDate(date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            parseDate(date) {
                if (!date) return null

                const [day, month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            ObtenerReportes() {
                let formData = new FormData();
                formData.append("npid", this.docto.npid);
                Recepcion.ReportesEnviados(this, formData).then(data => {
                    this.reportes = data;
                });
            },
            Guardar() {
                
                    let d = this.selected;
                    let noselected = '';
                    let datos = [];
                    this.reportes.forEach(function (data) {
                        let f = d.find(selec => selec.Reporte === data.Reporte);
                        if (f == undefined) {
                            noselected += data.Reporte + '<br/>';
                            datos.push(data);
                        }
                    });
                    this.comentarios = this.comentarios.trim();
                    this.comentarios = this.comentarios.replace(/\s*$/, "");
                    if (this.$refs.frm.validate() && this.comentarios.length >= 12) {
                        var reportes = '';
                        this.selected.forEach(function (data) {
                            reportes += data.Reporte + '/';
                        });
                        
                        let formData = new FormData();
                        formData.append("id", this.docto.npid);
                        formData.append("fecha", this.date);
                        formData.append("observacion", this.comentarios);
                        formData.append("reportes", reportes);
                        formData.append("noseleccionado", noselected);
                        formData.append("datos", JSON.stringify(datos));
                        this.$swal({
                            title: "Guardando, espere un momento...",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                        this.$swal.showLoading();
                        //
                        Recepcion.GuardaRecepcionDocto(this, formData).then(data => {
                            if (data[0].success == 'true') {
                                this.$swal({
                                    position: "center",
                                    icon: "success",
                                    title: "Éxito",
                                    text: "Los registros se guardaron correctamente",
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    showConfirmButton: true,
                                    timer: 2000,
                                    confirmButtonText: "Ok!",
                                }).then(() => {
                                    this.$router.push({ name: `DoctoPendiente` });
                                });
                            }
                            else {
                                this.$swal({
                                    position: "center",
                                    icon: "error",
                                    title: "Error",
                                    text: "No se pudo guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    showConfirmButton: true,
                                    confirmButtonText: "Ok!",
                                });
                            }
                        });

                    }

            },
            Limpiar() {
                this.comentarios = '';
                this.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            },
            Regresar() {
                this.$router.push({ name: `DoctoPendiente` });
            },
            ObtenerFecha() {
                let formdata = new FormData();
                formdata.append("npid", this.docto.npid);
                Recepcion.ObtenerFecha(this, formdata).then(data => {
                    this.mindate = this.parseDate(data[0].npfhenvio);
                });

            }
        },
        mounted() {
            if (this.docto == undefined)
                this.Regresar();
            if (this.docto.pqnombre != '')
                this.valpq = false
            this.ObtenerReportes();
            this.ObtenerFecha();
            this.overlay = true;
        }
    }
</script>